var _defs, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBenefitProduktion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.02 34.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #defc70;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.59 19.6 21.22 14.53 20.26 13.65 16.19 18.12 13.78 15.32 12.79 16.17 15.74 19.59 16.59 19.6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.11,6.25l-.42-.52h-.32c-3.8-.09-7.45-1.3-10.87-3.6l-.16-.11h-.67l-.16.11c-3.4,2.28-7.03,3.49-10.8,3.59h-.27s-.18.2-.18.2c-.06.06-.13.12-.14.13l-.22.19v16.26l1.54,3.18,10.28,6.32h.59s10.16-6.34,10.16-6.34l1.65-3.18V6.25ZM27.81,22.16l-1.34,2.58-9.47,5.91-9.56-5.88-1.24-2.57V7c3.77-.18,7.41-1.41,10.81-3.64,3.4,2.23,7.03,3.46,10.81,3.64v15.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.67,6.71c-2.29,1.26-4.7,2.14-7.15,2.6l-.26.05-.36.54v10.56s.07.13.07.13c.02.05.29.61.56,1.17.29.61.58,1.21.58,1.22l.08.14,6.81,4.32,6.71-4.22,1.4-2.62v-10.61l-.04-.28-.3-.36-.23-.04c-2.47-.46-4.89-1.34-7.2-2.62l-.19-.08h-.33l-.15.08ZM23.81,10.51v9.78l-1.09,2.03-5.72,3.6-5.83-3.69c-.1-.21-.29-.61-.48-1.01-.19-.41-.39-.82-.5-1.04v-9.67c2.33-.49,4.62-1.33,6.81-2.5,2.19,1.17,4.48,2.01,6.81,2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBenefitProduktion);
export default __webpack_public_path__ + "static/media/Icons_Benefit_Produktion.654b89ebff5faba4f162dea71d340522.svg";
export { ForwardRef as ReactComponent };